import React, { useState } from 'react';
import { makeStyles, Typography, Chip, Slider } from '@material-ui/core';
import mockData, { chips } from '../mockData.js';
import HighlightOffTwoToneIcon from '@material-ui/icons/HighlightOffTwoTone';
import Results from '../components/Results.js';
import { useSelector } from 'react-redux';
import { selectStart } from '../features/StartSlice';
import { selectEnd } from '../features/EndSlice';


const SearchPages = () => {
	const classes = useStyles();
	const [value, setValue] = useState(400);
	const start = useSelector(selectStart);
	const end = useSelector(selectEnd);

	const handleChange = (e, newValue) => {
		setValue(newValue);
	};

	return (
		<div className={classes.root}>
			<Typography variant="h5" gutterBottom>
				Aviable Rooms
			</Typography>
			<div className={classes.chips}>
				{chips.map((data) => {
					let icon = <HighlightOffTwoToneIcon />;
					return (
						<Chip
							label={data.label}
							key={data.key}
							icon={icon}
							className={classes.chip}
						/>
					);
				})}
			</div>
			<div className={classes.selector}>
				<Typography gutterBottom>Prices</Typography>
				<Slider
					onChange={handleChange} 
					value={value}
					aria-labelledby="continuous-slider" 
					min={0} 
					max={400} 
					valueLabelDisplay="auto"
					color="secondary"
				/>
			</div>
			{
				mockData
				.filter((data)=> data.cat === 'room')
				.filter((data) => data.price < value)
				.filter((data) => end < data.notAvailablestart || 
					start > data.notAvailableend)
				.map(({src, title, description, price, stock}, index) => (

					<Results 
						title={title}
						key={index}
						src={src}
						description={description}
						price={price}
						stock={stock}
					/>
				))
			}
		</div>
	);
};

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2),
  },
  chips: {
  	padding: theme.spacing(1),
  },
  chip: {
  	margin: theme.spacing(1),
  },
  selector: {
  	width: "300px",
  	margin: theme.spacing(1,0,1,3)
  }
  
}));

export default SearchPages